<template>
  <footer class="mx-auto max-w-7xl p-4 bg-white rounded-lg md:py-8 dark:bg-gray-900">
    <div class="sm:flex sm:items-center sm:justify-between">
        <router-link :to="{ name: 'home' }" class="flex items-center mb-4 sm:mb-0">
          <img src="@/assets/logo-dark.svg" class="h-8 mr-3" :alt="$t('ui.logo')" />
        </router-link>
        <ul class="flex flex-wrap items-center mb-6 text-sm text-gray-500 sm:mb-0 dark:text-gray-400 space-x-4 md:space-x-6">
          <li v-for="item in menu" :key="item.url">
            <a :href="item.url" class="hover:underline">{{ item.name.value }}</a>
          </li>
        </ul>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div class="mx-auto max-w-4xl space-y-2 text-sm text-gray-500 sm:text-center dark:text-gray-400">
      <p class="font-semibold text-gray-700 dark:text-gray-300">Товарищество с ограниченной ответственностью "Компания АЗиЯ 2012"</p>
      <p>БИН 120140014929</p>
      <p>Юридический адрес: ГОРОД АСТАНА, РАЙОН ЕСИЛЬ, ШОССЕ КОРГАЛЖЫН, д. 19, сектор А, оф. 200</p>
      <p>
        Телефоны:
        <a class="hover:underline" href="tel:+77172793147">+7 (7172) 79 31 47</a>,
        <a class="hover:underline" href="tel:+77012448723">+7 (701) 244 87 23</a>
      </p>
      <p>
        Email: <a class="hover:underline" href="mailto:azia_2012@inbox.ru">azia_2012@inbox.ru</a>
      </p>
      <p>
        <router-link :to="{ name: 'privacy-policy' }" class="font-medium text-blue-600 hover:underline dark:text-blue-400">
          Политика конфиденциальности и обработки персональных данных
        </router-link>
      </p>
      <p>{{ $t('footer.rights') }}</p>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const menu = [
  {
    name: computed(() => t("menu.home")),
    url: '/#home',
  },
  {
    name: computed(() => t("menu.about-us")),
    url: '/#about-us',
  },
  {
    name: computed(() => t("menu.contacts")),
    url: '/#contacts',
  },
  {
    name: computed(() => t("menu.requisites")),
    url: '/#requisites',
  },
];
</script>
